import { Menu, X, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Link, useLocation } from "react-router-dom";
import logoDraNatalia from "@/assets/logo-dra-natalia.png";
import { useState } from "react";
import { trackWorkingLead } from "@/lib/utils";

const Header = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Início", path: "/" },
    { name: "Smile & Beauty", path: "/doutores" },
    { name: "Tratamentos", path: "/servicos" },
    { name: "Blog", path: "/blog" }
  ];

  const isActive = (path: string) => location.pathname === path;
  
  const handleWhatsAppClick = () => {
    trackWorkingLead();
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-effect border-b border-border/50 shadow-elevated">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo - Left */}
          <Link to="/" className="flex items-center animate-fade-in">
            <img 
              src={logoDraNatalia} 
              alt="Dra. Natália Piller" 
              className="h-12 md:h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation - Center */}
          <nav className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-foreground ${
                  isActive(item.path) ? "text-foreground font-semibold" : "text-foreground/70"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Right (Desktop) */}
          <div className="hidden lg:block">
            <Button className="hover-lift shadow-blue bg-accent hover:bg-accent/90" asChild>
              <a href="https://api.whatsapp.com/send?phone=5511963140057&text=Ol%C3%A1%20vim%20do%20site.%20Quero%20mais%20informa%C3%A7%C3%B5es." target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>
                Agendar Consulta
              </a>
            </Button>
          </div>

          {/* Mobile Navigation */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" aria-label="Menu de navegação">
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </Button>
            </SheetTrigger>
            <SheetContent side="top" className="w-full border-b">
              <div className="flex flex-col gap-6 mt-8 pb-6">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`text-lg font-medium transition-all duration-300 hover:text-foreground hover:translate-x-2 ${
                      isActive(item.path) ? "text-foreground font-semibold" : "text-foreground/70"
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                <Button className="hover-lift shadow-blue bg-accent hover:bg-accent/90 w-full" asChild>
                  <a href="https://api.whatsapp.com/send?phone=5511963140057&text=Ol%C3%A1%20vim%20do%20site.%20Quero%20mais%20informa%C3%A7%C3%B5es." target="_blank" rel="noopener noreferrer" onClick={() => { setIsOpen(false); handleWhatsAppClick(); }}>
                    Agendar Consulta
                  </a>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;